const KEY = 'slack-monitoring-v1';

const seed = {
  channels: ['#general', '#security-updates', '#compliance-alerts'],
  messages: [
    { id: 'sm-001', ts: '2025-09-16T09:15:00Z', channel: '#compliance-alerts', type: 'post', severity: 'info', status: 'success', text: 'Policy update posted', meta: { by: 'bot', workspace: 'corp' } },
    { id: 'sm-002', ts: '2025-09-16T08:55:00Z', channel: '#general', type: 'post', severity: 'high', status: 'error', text: 'Failed to post status', meta: { by: 'app', workspace: 'corp' } },
    { id: 'sm-003', ts: '2025-09-16T08:30:00Z', channel: '#security-updates', type: 'post', severity: 'info', status: 'success', text: 'Security bulletin pushed', meta: { by: 'bot', workspace: 'corp' } },
  ],
  alerts: [
    { id: 'al-001', name: 'Compliance Errors', channel: '#compliance-alerts', match: 'error|failed', severity: 'high', enabled: true },
    { id: 'al-002', name: 'Security Updates', channel: '#security-updates', match: 'security|patch', severity: 'info', enabled: true },
  ],
};

function load(){ try{ const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) : seed; }catch{ return seed; } }
let state = load();
const subs = new Set();
function save(){ try{ localStorage.setItem(KEY, JSON.stringify(state)); }catch{} }
function publish(){ save(); subs.forEach(cb=> { try{ cb(state); }catch{} }); }

export function subscribe(cb){ subs.add(cb); cb(state); return ()=> subs.delete(cb); }
export function listChannels(){ return state.channels || []; }
export function addChannel(name){ if(!name) return; if(!state.channels.includes(name)) { state.channels.push(name); publish(); } }
export function removeChannel(name){ state.channels = (state.channels||[]).filter(c=> c!==name); publish(); }
export function stats(){
  const total = state.messages.length;
  const success = state.messages.filter(m=> m.status==='success').length;
  const errors = state.messages.filter(m=> m.status==='error').length;
  const channels = Array.from(new Set(state.messages.map(m=> m.channel))).length;
  return { total, success, errors, channels };
}
export function listMessages(){ return state.messages.slice().sort((a,b)=> new Date(b.ts) - new Date(a.ts)); }
export function searchMessages({ q='', channel='all', status='all', severity='all', type='all', from=null, to=null }={}){
  const query = q.trim().toLowerCase();
  const fromDt = from ? new Date(from) : null;
  const toDt = to ? new Date(to) : null;
  return listMessages().filter(m=>{
    if(channel!=='all' && m.channel!==channel) return false;
    if(status!=='all' && m.status!==status) return false;
    if(severity!=='all' && m.severity!==severity) return false;
    if(type!=='all' && m.type!==type) return false;
    const t = new Date(m.ts);
    if(fromDt && t < fromDt) return false;
    if(toDt && t > toDt) return false;
    if(!query) return true;
    return [m.text,m.channel,m.type,m.severity,m.status].some(v=> String(v||'').toLowerCase().includes(query));
  });
}
export function upsertMessage(msg){
  const idx = state.messages.findIndex(x=> x.id===msg.id);
  const payload = { id: msg.id || `sm-${Math.random().toString(36).slice(2,7)}`, ts: new Date().toISOString(), status:'success', severity:'info', type:'post', ...msg };
  if(idx>=0) state.messages[idx] = { ...state.messages[idx], ...payload };
  else state.messages.unshift(payload);
  publish();
  return payload;
}
export function removeMessage(id){ state.messages = state.messages.filter(m=> m.id!==id); publish(); }

export function simulateMessages(count=5, errorRate=0.2){
  const channels = listChannels();
  for(let i=0;i<count;i++){
    const ch = channels[Math.floor(Math.random()*channels.length)] || '#general';
    const isError = Math.random() < errorRate;
    upsertMessage({
      channel: ch,
      text: isError ? 'Simulated failure to post update' : 'Simulated message delivered',
      severity: isError ? 'high' : 'info',
      status: isError ? 'error' : 'success',
      type: 'event',
    });
  }
}

export function listAlerts(){ return state.alerts; }
export function upsertAlert(alert){
  const idx = state.alerts.findIndex(x=> x.id===alert.id);
  const payload = { id: alert.id || `al-${Math.random().toString(36).slice(2,7)}`, enabled:true, severity:'info', channel:'#general', match:'', ...alert };
  if(idx>=0) state.alerts[idx] = { ...state.alerts[idx], ...payload };
  else state.alerts.push(payload);
  publish();
  return payload;
}
export function removeAlert(id){ state.alerts = state.alerts.filter(a=> a.id!==id); publish(); }

export function exportJSON(){ return state; }
export function importJSON(obj){ if(!obj) return; state = obj; publish(); }
export function exportCSV(){
  const rows = [['id','ts','channel','type','severity','status','text']];
  state.messages.forEach(m=> rows.push([m.id,m.ts,m.channel,m.type,m.severity,m.status,(m.text||'').replace(/\n/g,' ')]));
  return rows;
}
